<template>
  <div>
    <div class="app clearfix">
      <div class="title">
        <div>
          <div
            :style="{ background: 'url(' + require('@/assets/' + cardMsg['img']) + ') no-repeat center center', backgroundSize: '100% 100%'}"
          ></div>
        </div>

        <h3 class>{{cardMsg['h3']}}</h3>
        <p class v-for="(item, index) in cardMsg['p']" :key="index">{{item}}</p>
      </div>
      <div class="context">
        <div v-for="(item, index) in cardMsg['li']" :key="index" class="item-core">
          <div></div>
          <div>
            <p>{{item}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    cardMsg: {
      type: Object,
      required: true
    }
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.app {
  width: 366px;
  /* height: 500px; */
  /* position: absolute; */
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 18px 2px rgba(167, 167, 167, 0.2);
  border-radius: 6px;
}
.title {
  /* position: relative; */
  height: 320px;
  background: rgba(248, 248, 248, 1);
  border-radius: 6px 6px 0px 0px;
  color: rgba(51, 51, 51, 1);
  padding-top: 35px;
}
.title div {
  font-size: 24px;
  font-weight: bold;
  width: 140px;
  height: 140px;
}
/* .title div div {
} */
.title h3 {
  font-size: 24px;
  font-weight: bold;
  margin-top: 25px;
}
.title p {
  font-size: 18px;
  font-weight: normal;
  margin-top: 0px;
  padding-left: 36px;
  padding-right: 36px;
}
.context {
  padding-left: 0px;
  margin-left: -10px;
}
.context .item-core {
  text-align: left;
  margin-top: 10px;
  margin-left: 33px;
  width: 350px;
}
.context > :first-child {
  margin-top: 25px;
}
.context .item-core > :first-child {
  display: inline-block;
  width: 14px;
  height: 14px;
  background: rgba(74, 17, 118, 1);
  border-radius: 50%;
}
.context .item-core :nth-child(2) {
  width: 334px;
  height: 100%;
  text-align: left;
  margin-top: -26px;
  margin-left: 26px;
}
.context p {
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
}
/* .context .item-core :last-child {
  padding-bottom: 20px;
} */
.context .item-core p {
  display: inline-block;
  font-size: 14px;
  padding-left: 0px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
}
.context > :last-child :last-child {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/coreCard.vue